import { render, staticRenderFns } from "./digital_quota.vue?vue&type=template&id=4a9aa1f7&scoped=true"
import script from "./digital_quota.vue?vue&type=script&lang=js"
export * from "./digital_quota.vue?vue&type=script&lang=js"
import style0 from "./digital_quota.vue?vue&type=style&index=0&id=4a9aa1f7&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9aa1f7",
  null
  
)

export default component.exports